var Module = {
    name: 'errorHandler',
    selectors: {
        errorContainer: '#messageBox'
    },

    processBadRequest: function (data, form) {
        switch (data.code) {
            case 'user_exists':
                form.append('<input name="force" value="1" hidden>');
                $('#overlay').toggleClass('active');
                $('#resign_popup').toggleClass('active');
                break;
            case 'user_exists_discount':
                form.append('<input name="force" value="1" hidden>');
                $('#overlay').toggleClass('active');
                $('#resign_popup_discount').toggleClass('active');
                break;
            case 'user_already_referral':
                $('#overlay').toggleClass('active');
                $('#user_already_referral_popup').toggleClass('active');
                break;
            case 'minibox_onetime_not_new_user':
                $('#overlay').toggleClass('active');
                $('#minibox_onetime_not_new_user_popup').toggleClass('active');
                break;
            case 'split_onetime_limit':
                $('#overlay').toggleClass('active');
                $('#split_onetime_limit_popup').toggleClass('active');
                break;
            case 'referral_error':
                $('#overlay').toggleClass('active');
                $('#referral_error_popup').toggleClass('active');
                break;
            case 'user_has_active_minibox':
                $('#overlay').toggleClass('active');
                $('#has_active_minibox_popup').toggleClass('active');
                break;
        }
    },

    processTokenMismatch: function () {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
        window.location.reload(true);
    },

    toggleErrors: function (errors, container) {
        if (errors && Object.keys(errors).length > 0) {
            Module.showErrors(errors, container)
            return;
        }

        Module.hideErrors(container);
    },

    showErrors: function (errors, container) {
        container = container || $(Module.selectors.errorContainer);

        var output = '';
        $.each(errors, function(i, el) {
            output += '<label id="' + i + '-error" class="error" for="' + i + '">'
                + (typeof el === "string" ? el : el[0])
            + '</label>'
        });

        container.html(output);
        container.show();
    },

    hideErrors: function (container) {
        container = container || $(Module.selectors.errorContainer)
        container.hide();
        container.find('.error').remove();
    }
}

module.exports = Module
